import React, {
    Dispatch,
    ReactNode,
    SetStateAction,
    useEffect,
    useState,
} from "react";

import InforCaso from "../../../CardsPages/InforCaso";
import ContatosCliente from "../../ContatosCliente";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFileAlt,
    faHome,
    faHouseUser,
    faUserFriends,
} from "@fortawesome/free-solid-svg-icons";

import ProdutosCobranca from "../../../CardsPages/ProdutosCobranca";
import HistoricoClienteCobranca from "../../HistoricoClienteCobranca";

import Documentos from "../../../CardsPages/Documentos";
import { IAtendimento } from "../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Tab, Tabs } from "react-bootstrap";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { IDadosERP } from "../../../../Interfaces/Geral/ERP/ERPInterface";
import AcoesERP from "./AcoesERP";
import AcoesInteracao from "./AcoesInteracao";
import ProdutoInteresse from "../../ProdutoInteresse/ProdutoInteresse";
import { ACESSOS } from "../../../../Routes/Acessos";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import Proponentes from "../../Proponentes/Proponentes";
import { ListarCasoDocumentoController } from "../../../../Controllers/Geral/CasoDocumentos/CasoDocumentosController";

interface ITab {
    key: string;
    name: string;
    Component: React.FC<{}>;
    icon: IconProp;
}
interface IAtendimentoDetalhadoProps {
    Atendimento: IAtendimento;
    IDCaso: number;
    KPICard?: React.FC<any>;
    adicionalComponent?: ReactNode;
    buttons?: React.ReactNode;
    inicialTab?: ITab;
    extraTabs?: Array<ITab>;
    emccampMode?: string;
    ID_ORGANIZACAO?: string;

    activeTab?: string | undefined;
    setActiveTab?: Dispatch<SetStateAction<string | undefined>>;

    alerts?: Array<{
        show: boolean;
        text: string;
    }>;

    TIPO_CASO?: "Cobranca" | "Atendimento";
    dadosERP?: IDadosERP;
}

export default function AtendimentoDetalhado(
    props: IAtendimentoDetalhadoProps
) {
    const { IDCaso, Atendimento, dadosERP } = props;
    const { bloquearInteracoes } = useAtendimentoPage();

    const { id } = useModuloInfo();

    //const { historicoCaso } = useHistoricoContext();
    const Adicional = props.adicionalComponent;

    const [totalDocCaso, setTotalDocCaso] = useState(0);

    async function calcularTotalDocCaso() {
        const res = await ListarCasoDocumentoController(props.IDCaso);
        setTotalDocCaso(res.length);
    }

    useEffect(() => {
        calcularTotalDocCaso();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.IDCaso]);

    const alertsDiv = props.alerts?.map((alert) => (
        <>
            {alert.show && (
                <div
                    className="alert alert-custom alert-light-warning fade show mb-5"
                    role="alert"
                >
                    <div className="alert-icon">
                        <i className="flaticon-warning"></i>
                    </div>
                    <div className="alert-text">{alert.text}</div>
                    <div className="alert-close">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">
                                <i className="ki ki-close"></i>
                            </span>
                        </button>
                    </div>
                </div>
            )}
        </>
    ));

    return (
        <div className="row no-gutters w-100">
            <div className="col-12 col-lg-8">
                <div className="d-flex flex-column col-12">
                    <InforCaso
                        Atendimento={Atendimento}
                        KPIsCard={props.KPICard}
                    />

                    {alertsDiv}

                    {dadosERP && <AcoesERP dadosERP={dadosERP} />}

                    <div>
                        <Tabs
                            activeKey={
                                props.activeTab ? props.activeTab : undefined
                            }
                            onSelect={(k) =>
                                props.activeTab
                                    ? props.setActiveTab?.(k ?? "")
                                    : undefined
                            }
                            mountOnEnter
                        >
                            {props.inicialTab && (
                                <Tab
                                    title={
                                        <>
                                            <FontAwesomeIcon
                                                className="mr-2"
                                                icon={props.inicialTab.icon}
                                            />
                                            {props.inicialTab.name}
                                        </>
                                    }
                                    eventKey={props.inicialTab.key}
                                >
                                    <props.inicialTab.Component />
                                </Tab>
                            )}

                            {ACESSOS.VENDAS.ID_MODULO === id && (
                                <Tab
                                    title={
                                        <>
                                            <FontAwesomeIcon
                                                className="mr-2"
                                                icon={faHouseUser}
                                            />
                                            Produto de Interesse
                                        </>
                                    }
                                    eventKey="#produtoInteresse"
                                >
                                    <ProdutoInteresse />
                                </Tab>
                            )}

                            {ACESSOS.VENDAS.ID_MODULO === id && (
                                <Tab
                                    title={
                                        <>
                                            <FontAwesomeIcon
                                                className="mr-2"
                                                icon={faUserFriends}
                                            />
                                            Proponentes
                                        </>
                                    }
                                    eventKey="#proponentes"
                                >
                                    <Proponentes />
                                </Tab>
                            )}

                            <Tab
                                title={
                                    <>
                                        <FontAwesomeIcon
                                            className="mr-2"
                                            icon={faHome}
                                        />
                                        Unidades
                                    </>
                                }
                                eventKey="#unidades"
                            >
                                <ProdutosCobranca
                                    idConta={Atendimento.ID_CONTA}
                                    idProdutoAtendimento={
                                        Atendimento.ID_PRODUTO
                                    }
                                />
                            </Tab>

                            <Tab
                                title={
                                    <>
                                        <FontAwesomeIcon
                                            className="mr-2"
                                            icon={faUserFriends}
                                        />
                                        Contatos
                                    </>
                                }
                                eventKey="#contatos"
                            >
                                <div className="card card-custom">
                                    <ContatosCliente
                                        idConta={props.Atendimento.ID_CONTA}
                                        ID_CHAVE_ERP={
                                            props.Atendimento.ID_CHAVE_ERP_CONTA
                                        }
                                        idCaso={props.IDCaso}
                                    />
                                </div>
                            </Tab>
                            <Tab
                                title={
                                    <>
                                        <FontAwesomeIcon
                                            className="mr-2"
                                            icon={faFileAlt}
                                        />
                                        Documentos ( {totalDocCaso} )
                                    </>
                                }
                                eventKey="#docs"
                            >
                                <div className="card card-custom">
                                    <Documentos
                                        IDCaso={IDCaso}
                                        IdConta={Atendimento.ID_CONTA}
                                        totalDocCaso={totalDocCaso}
                                        setTotalDocCaso={setTotalDocCaso}
                                        tipoExibicao={"CASO"}
                                    />
                                </div>
                            </Tab>

                            {props.extraTabs &&
                                props.extraTabs.map((tab) => (
                                    <Tab
                                        title={
                                            <>
                                                <FontAwesomeIcon
                                                    className="mr-2"
                                                    icon={tab.icon}
                                                />
                                                {tab.name}
                                            </>
                                        }
                                        eventKey={tab.key}
                                        key={tab.key}
                                    >
                                        <tab.Component />
                                    </Tab>
                                ))}
                        </Tabs>
                    </div>

                    <div>{Adicional}</div>
                </div>
            </div>
            <div className="col-12 col-lg-4">
                {/* <div className="d-flex flex-column col-12 gutter-b">
                    <ContatosCliente
                        idConta={props.Atendimento.ID_CONTA}
                        ID_CHAVE_ERP={props.Atendimento.ID_CHAVE_ERP_CONTA}
                        idCaso={props.IDCaso}
                    />
                </div> */}

                <AcoesInteracao />
                <div className="d-flex flex-column col-12 gutter-b">
                    <HistoricoClienteCobranca
                        ID_CASO={Atendimento.ID_CASO}
                        ID_CHAVE_ERP={Atendimento.ID_CHAVE_ERP_CONTA}
                    />
                </div>
                <div className="col-12 gutter-b">
                    {!bloquearInteracoes && props.buttons}
                </div>
            </div>
        </div>
    );
}
